import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBCXpfSKkJx6ZQz_LPjZm0bD8gWz421ObQ",
  authDomain: "the-social-hub-c8775.firebaseapp.com",
  projectId: "the-social-hub-c8775",
  storageBucket: "the-social-hub-c8775.appspot.com",
  messagingSenderId: "616778356724",
  appId: "1:616778356724:web:849fd36a063e6de8c84ba1"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();

export default db;
